/* ------------------------------------------------
** 可横向滚动栏目
** 支持添加左右滑动按钮
** item不能添加margin属性
格式如下：
<button class="scroll-menu-navigation scroll-menu-left" data-scroll-name="name">左滑</button>
<button class="scroll-menu-navigation scroll-menu-right" data-scroll-name="name">右滑</button>
<div class="scroll-menu" data-scroll-name="name">
    <div class="item">xxx</div>
    <div class="item">xxx</div>
    <div class="item active">xxx</div>
    <div class="item">xxx</div>
</div>
--------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
    const scrollContainers = document.querySelectorAll(".scroll-menu");

    scrollContainers.forEach((container) => {
        let isDown = false;
        let startX;
        let currentScrollLeft;
        let isDragging = false;
        const clickThreshold = 10;

        // 鼠标按下事件
        container.addEventListener("mousedown", (e) => {
            isDown = true;
            isDragging = false;
            startX = e.pageX - container.offsetLeft;
            currentScrollLeft = container.scrollLeft;

            container.addEventListener("mousemove", handleMouseMove);
        });

        // 鼠标移动处理
        function handleMouseMove(e) {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - container.offsetLeft;
            const walk = (x - startX) * 3;

            if (Math.abs(walk) > clickThreshold) {
                isDragging = true;
            }

            container.scrollLeft = currentScrollLeft - walk;
        }

        // 鼠标弹起事件
        window.addEventListener("mouseup", () => {
            isDown = false;
            container.removeEventListener("mousemove", handleMouseMove);
        });

        // 鼠标离开事件
        container.addEventListener("mouseleave", () => {
            isDown = false;
            container.removeEventListener("mousemove", handleMouseMove);
        });

        // 阻止拖动时链接的默认行为
        container.querySelectorAll(".item a").forEach((link) => {
            link.addEventListener("click", (e) => {
                if (isDragging) {
                    e.preventDefault();
                }
            });
        });

        // 获取对应的左滑和右滑按钮
        const scrollLeftButton = document.querySelector(`.scroll-menu-left[data-scroll-name="${container.dataset.scrollName}"]`);
        const scrollRightButton = document.querySelector(`.scroll-menu-right[data-scroll-name="${container.dataset.scrollName}"]`);

        // 向左滑动的函数
        function scrollLeft() {
            const items = container.querySelectorAll('.item');
            const firstVisibleIndex = getFirstVisibleItemIndex(container, items);
            if (firstVisibleIndex > 0) {
                const previousItem = items[firstVisibleIndex - 1];
                scrollToItem(container, previousItem);
            }
        }

        // 向右滑动的函数
        function scrollRight() {
            const items = container.querySelectorAll('.item');
            const firstVisibleIndex = getFirstVisibleItemIndex(container, items);
            if (firstVisibleIndex < items.length - 1) {
                const nextItem = items[firstVisibleIndex + 1];
                scrollToItem(container, nextItem);
            }
        }

        // 左滑按钮点击事件
        if (scrollLeftButton) {
            scrollLeftButton.addEventListener("click", scrollLeft);
        }

        // 右滑按钮点击事件
        if (scrollRightButton) {
            scrollRightButton.addEventListener("click", scrollRight);
        }
        // 页面加载时，自动滚动到指定位置的 active 元素
        scrollToActive(container, 1);
    });

    // 获取第一个完全可见的 item 的索引
    function getFirstVisibleItemIndex(container, items) {
        const containerRect = container.getBoundingClientRect();
        for (let i = 0; i < items.length; i++) {
            const itemRect = items[i].getBoundingClientRect();
            if (itemRect.left >= containerRect.left && itemRect.right <= containerRect.right) {
                return i; // 返回第一个完全可见的 item 索引
            }
        }
        return 0; // 如果没有找到完全可见的，则默认返回第一个
    }

    // 滚动到指定的 item
    function scrollToItem(container, item) {
        const itemRect = item.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        // 计算要滚动的距离，使得 item 出现在可见区域的开头
        const scrollDistance = itemRect.left - containerRect.left + container.scrollLeft;
        container.scrollTo({ left: scrollDistance, behavior: "smooth" });
    }

    // 滚动到带有 active 类的元素，并放置在第 n 个位置
    function scrollToActive(container, n) {
        const activeElement = container.querySelector(".item.active");
        if (activeElement) {
            const items = Array.from(container.querySelectorAll('.item'));
            const activeIndex = items.indexOf(activeElement);

            if (activeIndex >= 0) {
                const targetIndex = Math.max(activeIndex - n + 1, 0);//确保索引不小于0
                scrollToItem(container, items[targetIndex]);
            }
        }
    }
});